import { render } from "./ArticleInfo.vue?vue&type=template&id=02f6e4b4"
import script from "./ArticleInfo.vue?vue&type=script&lang=js"
export * from "./ArticleInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__